import {queryOptions} from "@tanstack/react-query"

import {fetch} from '../services/ProductsService'
import {productsQueryKeys} from '../hooks/productsQueryKeys'

export const createProductQueryOptions = (productId: string) => {

    return queryOptions(
        {
            queryKey: productsQueryKeys.detail(productId),
            queryFn: () => fetch(productId),
            enabled: !!productId,
            staleTime: 30_000,
        })

}
